import React from 'react';
import { FeatureMySkillsView } from './FeatureMySkills.view';
import { useQuery } from '@apollo/client';
import { QUERY_SOFT_SKILLS } from '../../../../graphql/query/note/softSkills.query';
import { useRefetchData } from '../../../../helpers/refetch/refetchData';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import FrontError from '../../../../helpers/errors/front.error';
import { QuerySoftSkillsQuery } from '../../../../graphql/generated/graphql';
import { mesComptencesFields } from '../../../../domain/note/mesCompetences';
import { getUserPerfsFromQuery } from '../../../../helpers/transformApiResponse/user';

export const FeatureMySkills = () => {
  const { data, loading, error, refetch } = useQuery<QuerySoftSkillsQuery>(
    QUERY_SOFT_SKILLS
  );
  useRefetchData(refetch);
  if (loading) return <LoadingContainer variant="MySkills" />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new FrontError(
            'Récupération des perfs commerciales / compétences',
            error
          )
        }
        text={
          "Veuillez recharger l'affichage des performances commerciales et compétences"
        }
        setFeedback
        needCaptureError={false}
      />
    );
  const user = getUserPerfsFromQuery(data?.getUserSoftSkills);

  return <FeatureMySkillsView radarData={mesComptencesFields(user.note)} />;
};
